<template>
  <div class="cx-modal--full" role="dialog">
    <div class="cx-modal__body" role="document">
      <button class="cx-btn cx-modal__close" @click.prevent="close" :aria-label="$t('action.close')">
        <i class="fas fa-fw fa-times"></i>
      </button>
      <div class="cx-card--notify">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cx-modal',
  methods: {
    close: function() {
      this.$emit('dismiss');
    }
  },
  uit() {
    return [
      ['action', ['close']]
    ]
  }
}

</script>